module.exports = __webpack_public_path__ + "media/audio1.c610932e.mp3";